'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarouselBrowserify = require('slick-carousel-browserify');

var _slickCarouselBrowserify2 = _interopRequireDefault(_slickCarouselBrowserify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    methods: {
        set_gallery_height: function set_gallery_height() {
            var _ = this;
            _.$project_slide.outerHeight(_.$information.innerHeight() / 4);
        }
    },
    props: ['images'],
    created: function created() {
        this.project_slider = null;
        this.$project_slider = null;
    },

    events: {
        /*this is triggered by app, we must set all the things only when all elements are ready*/
        'my_body_is_ready': function my_body_is_ready() {
            var _ = this;
            // we can cache the variables so we don't query dom every time we need them
            _.$project_slider = (0, _jquery2.default)('.project-slider');
            _.$information = (0, _jquery2.default)('.page__information');
            _.$project_slide = (0, _jquery2.default)('.project-slider__slide');

            // initial width
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            _.$project_slider.slick({
                dots: true,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                swipe: false,
                vertical: true,
                adaptiveHeight: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        swipe: true,
                        vertical: false,
                        variableHeight: false
                    }
                }]
            });

            if (width >= 768) {
                _.set_gallery_height();
            }

            (0, _jquery2.default)(window).on('resize', function () {
                if (width >= 768) {
                    _.set_gallery_height();
                }
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<section class=\"project-slider\" id=\"project-slider\">\n    <div v-for=\"image of images\" track-by=\"$index\" class=\"project-slider__slide\">\n        <div class=\"project-slider__image\" :style=\"{ 'background-image': 'url('+ image + ')'}\"></div>\n    </div>\n</section>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0e568b40", module.exports)
  } else {
    hotAPI.update("_v-0e568b40", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}